import axios from 'axios';

// token should be retrieved dynamically inside each function to ensure it's up to date
const getAuthHeaders = () => {
    const token = window.localStorage.getItem('authtoken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};
const postData = async (url, data) => {
    try {
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        return error.response.data;
    }
};

const post = async (url, data) => {
    try {
        const response = await axios.post(url, data, {
            headers: getAuthHeaders()
        });
        return response;
    } catch (error) {
        return error.response?.data || { error: "Network Error" };
    }
};

const put = async (url, data) => {
    try {
        const response = await axios.put(url, data, {
            headers: getAuthHeaders()
        });
        return response;
    } catch (error) {
        return error.response?.data || { error: "Network Error" };
    }
};
const getByIdWithToken = async (url, id) => {
    try {
        const response = await axios.get(`${url}/${id}`, {
            headers: getAuthHeaders()
        });
        return response;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

const getById = async (url) => {
    try {
        const response = await axios.get(url, {
            headers: getAuthHeaders()
        });
        return response;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};





const getlist = async (url) => {
    try {
        const response = await axios.get(`${url}`, {
            headers: getAuthHeaders()
        });
        return response;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

const getlistwithouttoken = async (url,) => {
    try {
        const response = await axios.get(`${url}`, {
        });
        return response;
    } catch (error) {
        // Handle error here if needed
        console.error("Error fetching data:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
};

const deleteitem = async (url, id) => {
    try {
        const response = await axios.delete(`${url}/${id}`, {
            headers: getAuthHeaders()
        });
        return response;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

export { postData, post, getByIdWithToken, getById, getlist, getlistwithouttoken, put, deleteitem };